import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Footer from '../components/Footer';
import Menu from '../components/Menu';

import '../styles/global.scss';

const PostLayout = (props) => {
  const { children, data } = props;
  const { defaultBanner } = data;

  return (
    <div>
        <Menu />
        
        {children({...props, defaultBanner})}

        <Footer />
    </div>
  );
};

PostLayout.propTypes = {
  children: PropTypes.func,
}

export default PostLayout;

export const query = graphql`
  query defaultDatasPostQuery {
    defaultBanner: imageSharp(id: { regex: "/header/banner.jpg/" }) {
      sizes(maxWidth: 1400, maxHeight: 300, cropFocus: CENTER) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/post.jsx